module.exports = __webpack_public_path__ + "static/media/amazon_color.2e923fba.png";